export default __webpack_public_path__ + "media/76d85f6daa92b5e6634c2a42cf7765b0c9d5642892ecf9b5795ea67393f44d45.svg";